
import HtmlMapper from './html-mapper.vue'

export default {
  components: {HtmlMapper},
  props: {
    nodes: {type: NodeList, required: true},
    restricted: {type: Boolean, default: false},
    defaultExpanded: {type: Boolean, default: true},
  },
  data() {
    return {
      section_states: new Map(),
    }
  },
  computed: {
    blocks() {
      const blocks = [{heading: null, content: document.createDocumentFragment()}]
      let block = blocks[0]
      this.nodes.forEach(node => {
        if (node.nodeName === 'H1') {
          block = {heading: node, content: document.createDocumentFragment()}
          blocks.push(block)
        } else {
          block.content.appendChild(node.cloneNode(true))
        }
      })
      return blocks.map((block, index) => ({
        index,
        heading: block.heading,
        content: block.content.childNodes,
      }))
    },
    preamble() {
      return this.blocks[0].content
    },
    sections() {
      return this.blocks.slice(1)
    },
    all_expanded() {
      return this.sections.every(section => this.isExpanded(section.index))
    },
  },
  watch: {
    defaultExpanded() {
      this.section_states.clear()
    },
  },
  methods: {
    isExpanded(index) {
      return this.section_states.get(index) ?? this.defaultExpanded
    },
    toggleSection(index) {
      this.section_states.set(index, !this.isExpanded(index))
    },
    toggleAll() {
      const expanded = !this.all_expanded
      this.section_states = new Map(this.sections.map(section => [section.index, expanded]))
    },
  },
}
